import { hiddenContentStyle } from '../../Styling';
export var getStyles = function getStyles(props) {
  return {
    root: props.className,
    screenReaderText: hiddenContentStyle
  };
};